"use client";

import { LogIn } from "lucide-react";
import { useAuthContext } from "@core/helpers/client/contexts/AuthContext";
import { openAuthModal } from "@/hooks/useAuthModal";
import UserDropdown from "./_userDropdown";
import { usePathname } from "next/navigation";

const AuthButtonModal = () => {

    const { is_auth } = useAuthContext();

    const pathname = usePathname();
    const isBlog = pathname.startsWith("/blogs")

    return (

        <div className="hidden lg:block">
            {is_auth ? (
                <UserDropdown />
            ) : (
                <div className="flex items-center justify-center bg-jmt-white border border-jmt-neutral-200 hover:bg-jmt-neutral-100 rounded-md p-2">
                    <button
                        type="button"
                        onClick={() => openAuthModal()}
                        className="flex items-center gap-1 text-jmt-neutral-900 cursor-pointer"
                    >
                        <LogIn size={20} />
                        <span className="whitespace-nowrap text-sm font-bold leading-6">
                            ورود | ثبت نام
                        </span>
                    </button>
                </div>
            )}
        </div>
    );
}

export default AuthButtonModal;